import {
  createSlice,
  createEntityAdapter,
  createAsyncThunk,
  createSelector,
} from '@reduxjs/toolkit'

import {  parse } from 'date-fns'

import visitorService from '../services/visitorService'
import { generatePath } from 'react-router-dom'
import { generatePhoneDetail } from '../utils/phoneUtil'


export const refreshlVisitors = createAsyncThunk('visitor/refreshlVisitors', 
  async (photo, {getState}) => {
  const response = await visitorService.fetchAll(0, 0)
    return response.data
})

export const fetchAllVisitors = createAsyncThunk('visitor/fetchAllVisitors', 
  async (_,{getState}) => {
    const timestamp = selectVisitorMaxTimestamp(getState())
    const response = await visitorService.fetchAll(0, timestamp)
    return response.data
})

export const fetchVisitor = createAsyncThunk('visitor/fetchVisitor', 
  async (id) => {
    const response = await visitorService.fetch(id)
    return response.data
})
export const createVisitor = createAsyncThunk('visitor/createVisitor', 
  async (visitor) => {
    const response = await visitorService.create(visitor)
    return response.data
})
export const updateVisitor = createAsyncThunk('visitor/updateVisitor', 
  async (visitor) => {
    const response = await visitorService.update(visitor)
    return response.data
})
export const deleteVisitor = createAsyncThunk('visitor/deleteVisitor', 
  async (id) => {
    const response = await visitorService.delete(id)
    return response.data
})


const addVCols = (x)=>{
  // try
  // {
  //   x.timestamp = x.updatedTm ? parse(x.updatedTm, 'dd/MM/yyyy HH:mm:ss', new Date()).getTime(): 1000;
  // }
  // catch (ex)
  // { 
  //     alert(ex)
  //     console.error(ex)
  // } 
  generatePhoneDetail(x)
  return x;
}

const visitorAdapter = createEntityAdapter({
  selectId: (entity) => entity.id,
  sortComparer: (a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())
})

const initialState = visitorAdapter.getInitialState({
  status: 'idle',
  error: null,
  timestamp: 0,
  lastFetched:0,
  });


const visitorSlice = createSlice({
  name: 'visitor',
  initialState: initialState,
  reducers: {
	    visitorsSyncLoaded: 
      {
      reducer(state, action) {
        state.lastFetched=(new Date()).getTime();
        if (action.payload && action.payload.length>0)
        {
          action.payload.forEach( addVCols);
            
        }
        visitorAdapter.setAll(state,action.payload)
		},
		prepare(visitorList) 
		{
			return {payload: visitorList}
		}
    },

    clearVisitors(state, action) {
        state.error=null
        state.status='idle'
        state.timestamp=0;
        visitorAdapter.removeAll(state)
    }
  },
  extraReducers(builder) {
    builder
      .addCase(refreshlVisitors.pending, (state, action) => {
        state.status = 'loading'
        state.error=null
      })
      .addCase(refreshlVisitors.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.lastFetched=(new Date()).getTime();
        if (action.payload && action.payload.length>0)
        {
          action.payload.forEach( addVCols);
            
        }
        visitorAdapter.setAll(state, action.payload)
        //console.error(action.payload);
      })
      .addCase(refreshlVisitors.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
      })

      .addCase(fetchAllVisitors.pending, (state, action) => {
        state.status = 'loading'
        state.error=null
      })
      .addCase(fetchAllVisitors.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.lastFetched=Date.now();
        if (action.payload && action.payload.length>0)
        {
          action.payload.forEach( addVCols);
          visitorAdapter.upsertMany(state, action.payload)
        }
      })
      .addCase(fetchAllVisitors.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
      })
      .addCase(fetchVisitor.fulfilled, (state, action) => 
      {
        if (action.payload) {
            addVCols(action.payload, 0)
            visitorAdapter.upsertOne(state, action.payload)
        }
      })
      .addCase(createVisitor.fulfilled, (state, action) => {
          if (action.payload)
          {
            addVCols(action.payload, 0)
            state.timestamp=Math.max(state.timestamp, action.payload.timestamp )
            visitorAdapter.addOne(state,action.payload)
          }
        })
      .addCase(updateVisitor.fulfilled, (state, action) => {
        if (action.payload){
          addVCols(action.payload, 0)
          state.timestamp=Math.max(state.timestamp, action.payload.timestamp )
          visitorAdapter.upsertOne(state , action.payload)
        } 
      })
      .addCase(deleteVisitor.fulfilled, (state, action) => {
        // alert("action="+action)
        // alert(action.payload)
        visitorAdapter.removeOne(state,action.payload)
      })
  }
})


export const { visitorsSyncLoaded, clearVisitors } = visitorSlice.actions

export default visitorSlice.reducer;

export const {
  selectAll:  selectAllVisitors,
  selectById: xselectVisitorById,
  selectIds:  selectVisitorIds,
} = visitorAdapter.getSelectors((state) => state.visitor)

export const selectVisitorById = (id)=>(state)=>xselectVisitorById(state, id)
export const selectVisitorStatus = (state)=>state.visitor.status;
export const selectVisitorError = (state)=>state.visitor.error;
export const selectVisitorTimestamp = (state)=>state.visitor.timestamp;
export const selectVisitorLastFetched = (state)=>state.visitor.lastFetched;



export const selectVisitorByEmail =  
createSelector(
  [	selectAllVisitors, 	(state,email)=>email],
  (visitors, email) =>visitors.find(v => v.email===email)
)

export const selectVisitorByPhone = 
createSelector(
  [	selectAllVisitors, 	(state,phone)=>phone],
  (visitors, phone) =>visitors.find(v => v.phone===phone)
)


const tofilterVisitor= (v, filter)=>
{
  if (!Boolean(filter)) return true;
  let matchName = !Boolean(filter.name) || v.name.toLowerCase().indexOf(filter.name)>=0; 
  let matchEmail = !Boolean(filter.email) || v.email.indexOf(filter.email)>=0;
  let matchPhone = !Boolean(filter.phone) || v.phone.indexOf(filter.phone)>=0;
  let matchCompany = !Boolean(filter.company) || v.company.toLowerCase().indexOf(filter.company)>=0;
  return matchName && matchEmail && matchPhone && matchCompany;
}


export const selectVisitorByFilter = 
createSelector(
  [	selectAllVisitors, 	(state, filter)=>filter],
  (visitors, fff) =>visitors.filter( v=>tofilterVisitor(v, fff) ).map(x=>x.id)
)



export const selectAllCompanies = 
createSelector(
  [	selectAllVisitors],
  (visitors) =>visitors.map(x=>x.company).sort().
  
  filter((value, index, self)=> self.indexOf(value) === index)
)

export const selectAllEmails = 
createSelector(
  [	selectAllVisitors],
  (visitors) =>visitors.map(x=>x.email.toLowerCase()).sort()
)

export const selectAllPhones = 
createSelector(
  [	selectAllVisitors],
  (visitors) =>visitors.map(x=>x.phone).sort()
)

export const selectAllPhoneDispalys = 
createSelector(
  [	selectAllVisitors],
  (visitors) =>visitors.map(x=>x.phoneDisplay).sort()
)

//--------------------------------------------------------------------------------
export const selectVisitorMaxTimestamp = 
createSelector(
  [	selectAllVisitors],
  (visitors) =>
  {
      if (!visitors||visitors.length===0 ) return 0;
      let ts = visitors.map(x=>{
          let t=0; 
          try
          {
            t = x.updatedTm ? parse(x.updatedTm, 'dd/MM/yyyy HH:mm:ss', new Date()).getTime(): 0;
          }
          catch (ex)
          { 
                alert(ex)
                console.error(ex)
          } 
          return t;
      }).reduce( (e,f)=>Math.max(e,f));
      
      return ts;
  }
)
